import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 22a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.738 9.738 0 0 1-.788 3.9 10.098 10.098 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0 1 12 22zm-.6-8.5v3.425c0 .267.125.43.375.488.25.058.442-.03.575-.263l3.025-5.925a.467.467 0 0 0-.025-.487.475.475 0 0 0-.425-.238H12.75V7.025c0-.267-.125-.433-.375-.5s-.442.017-.575.25l-3.15 6c-.083.183-.08.35.012.5.092.15.23.225.413.225H11.4z",
		fill: "currentColor"
	})
});
export default SvgInsight;
